export enum EmployeeGender {
  Unknown = 0,
  Male = 1,
  Female = 2,
  Other = 3
}

export const EMPLOYEE_GENDER_OPTIONS = [
  { label: 'Unknown', value: EmployeeGender.Unknown },
  { label: 'Male', value: EmployeeGender.Male },
  { label: 'Female', value: EmployeeGender.Female },
  { label: 'Other', value: EmployeeGender.Other }
];

export function getDefaultAvatarAsset(gender?: number | null): string {
  switch (gender) {
    case EmployeeGender.Male:
      return 'assets/avatars/avatar-male.svg';
    case EmployeeGender.Female:
      return 'assets/avatars/avatar-female.svg';
    default:
      return 'assets/avatars/avatar-neutral.svg';
  }
}

export function getDisplayInitials(name?: string | null): string {
  const trimmed = (name ?? '').trim();
  if (!trimmed) {
    return '??';
  }

  const parts = trimmed.split(/\s+/).filter(Boolean);
  if (parts.length >= 2) {
    return `${parts[0][0]}${parts[parts.length - 1][0]}`.toUpperCase();
  }

  return trimmed.slice(0, 2).toUpperCase();
}
